import { styled } from '../jss-style';
import spinStyle from './spin';

const useSpinStyle = styled(spinStyle, 'spin');
export { spinStyle, useSpinStyle };
export default useSpinStyle;
